export enum TipoDestinoEnum {
  TodasUnidades = "5B04913A-6C46-4EBE-BFB3-F311EE9E0923",
  UmGrupoUnidades = "5B04913A-6C46-4EBE-BFB3-F311EE9E0924",
  UmaUnidade = "5B04913A-6C46-4EBE-BFB3-F311EE9E0925",
  Email = "5B04913A-6C46-4EBE-BFB3-F311EE9E0926",
  Portaria = "5B04913A-6C46-4EBE-BFB3-F311EE9E0927",
  UmaPessoa = "5B04913A-6C46-4EBE-BFB3-F311EE9E0928",
  UmCargo = "5B04913A-6C46-4EBE-BFB3-F311EE9E0929",
}
